
import { defineComponent, ref, reactive, nextTick, onMounted } from 'vue';
import { VXETable, VxeFormEvents, VxeFormInstance, VxeGridInstance, VxeToolbarInstance } from 'vxe-table'
import { VxeGridProps, VxePagerEvents } from 'vxe-table'
import request from '@/plugin/request';
import { getTableScroll } from '@/plugin/tools'
export default defineComponent({
    components: {

    },
    setup () {

        const tablePage = reactive({
            total: 0,
            currentPage: 1,
            pageSize: 100
        })

        const gridOptions = reactive<VxeGridProps>({
            height: 500,
            size: 'mini',
            round: true,
            autoResize: true,
            align: 'center',
            loading: false,
            data: [],
            columns: [
                { type: 'seq', width: 50 },
                { field: 'CARDNO', title: '卡号', minWidth: 50 },
                { field: 'VIPTYPENAME', title: 'VIP类型', minWidth: 50 },
                { field: 'VIPNAME', title: '名称', minWidth: 50 },
                { field: 'MOBIL', title: '手机', minWidth: 50 },
                { field: 'SEX', title: '性别', minWidth: 50 },
                { field: 'BIRTHDAY', title: '生日', minWidth: 50 },
                { field: 'OPENCARDDATE', title: '开卡日期', minWidth: 50 },
                { field: 'STORENAME', title: '开卡店仓', minWidth: 200 },
                { field: 'EMPLOYEENAME', title: '开卡员工', minWidth: 50 },
            ]
        })

        const searchEvent = () => {
            tablePage.currentPage = 1

        }

        const handlePageChange: VxePagerEvents.PageChange = ({ currentPage, pageSize }) => {
            tablePage.currentPage = currentPage
            tablePage.pageSize = pageSize

            handleQuery()

        }

        const handleQuery = async () => {

            request('/customer/burgeon/customer', { currentPage: tablePage.currentPage, pageSize: tablePage.pageSize }, { method: 'GET' }).then(response => {

                const { result } = response
                gridOptions.data = result.data
                tablePage.total = result.total
                console.log(result)

                // grid.data = result

            })
        }

        nextTick(() => {
            gridOptions.height = getTableScroll()

        })

        onMounted(() => {


            handleQuery()


        })

        return {
            tablePage,
            gridOptions,
            searchEvent,
            handlePageChange
        }

    }
});
